import { useCallback, useEffect, useState } from "react";
import AddandEditform from "../shared/components/HeroBanner/AddandEditform";
import Tableheadpanel from "../shared/components/HeroBanner/Tableheadpanel";
import { deleteBanner, getallBanner, saveBanners, updatedBanner } from "../shared/services/apihomebanner/apihomebanner";
import toast from "react-hot-toast";
import Tableview from "../shared/components/HeroBanner/Tableview";
import apiurl from "../shared/services/apiendpoint/apiendpoint";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import Cuspagination from "../shared/components/Courses/Cuspagination";

export default function Homebannerpage () {

    const [visible, setVisible] = useState(false);
    const [formdata,setFormdata]=useState({});
    const [page, setPage] = useState(1);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(10);
    const [desktopFile, setDesktopFile] = useState();
    const [mobileFile, setMobileFile] = useState();
    const [tempFilterValues, setTempFilterValues] = useState([]);
    const [colfilter, setcolFilter] = useState({});
    const [loading, setLoading] = useState(false);
    const [tabledata, setTabledata]=useState([]);
    const [globalFilter,setGlobalFilter]=useState('');
    const [totalRecords, setTotalRecords] = useState(0);

    let isMounted = true;

    const onPage = (page) => {
        setPage(page)
        setFirst(rows *(page -1));
        setRows(rows);
    }

    const openform=()=>{
        setFormdata({});
        setDesktopFile();
        setMobileFile();
        setVisible(true)
    }

    const handlechange = (e) => {
        const { name, files, value } = e.target;
        if (files && files[0]) {
            const file = files[0];
            setFormdata({ ...formdata, [name]: file });
            const reader = new FileReader();
            reader.onloadend = () => {
                if (name === "DesktopImage") setDesktopFile(reader.result);
                if (name === "MobileImage") setMobileFile(reader.result);
            };
            reader.readAsDataURL(file);
        } 
        else {
            setFormdata({ ...formdata, [name]: value });
        }
    };

    const handlesave=async (e)=>{
        e.preventDefault()
        setLoading(true)
        await saveBanners(formdata)
        toast.success("Successfully saved")
        getbanners();
        setVisible(false)
        setLoading(false)
    }

    const getbanners = useCallback(async ()=>{
        setLoading(true)
        try {
            const res= await getallBanner({first,rows,globalFilter,...colfilter});
            setTabledata(res?.resdata);
            setTotalRecords(res?.totallength);
        } catch (error) {
            console.error("Error in getbanners:", error);
        }
        setLoading(false)
    },[first,rows,globalFilter,colfilter]);

    useEffect(()=>{
        if(isMounted){ getbanners(); }
        return(()=>isMounted = false);
    },[first,rows,globalFilter,colfilter])

    const cusfilter = (field, value) => {
        setcolFilter(prev => ({ ...prev, [field]: {$in:value} }));
        setFirst(0);
    };

    const clearFilter = (event)=>{
        setcolFilter(null);
        setGlobalFilter('')
        setTempFilterValues([])
        setFirst(0)
    }

    const editfrom=(data)=>{
        setFormdata({...data});
        setVisible(true);
        setDesktopFile(data.DesktopImage ? apiurl()+"/"+data.DesktopImage : null);
        setMobileFile(data.MobileImage ? apiurl()+"/"+data.MobileImage : null);
    }

    const handleupdate=async (e)=>{
        e.preventDefault()
        setLoading(true)
        await updatedBanner(formdata)
        toast.success("Successfully updated")
        getbanners()
        setVisible(false)
        setLoading(false)
    }

    const handledelete = (id) => {
        confirmDialog({
            message: 'Do you want to delete this record?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            defaultFocus: 'reject',
            acceptClassName: 'bg-red-500 ml-2 text-white p-2',
            rejectClassName: 'p-2 outline-none border-0',
            accept:async ()=>{
             await deleteBanner(id)
             toast.success("Successfully deleted")
             getbanners()
            }
        });
    };

    return (
        <>
        <Tableheadpanel openform={openform} setGlobalFilter={setGlobalFilter} />
        <AddandEditform visible={visible} setVisible={setVisible} handlechange={handlechange} formdata={formdata} desktopFile={desktopFile} mobileFile={mobileFile}
            handlesave={handlesave} loading={loading} handleupdate={handleupdate} />
        <Tableview loading={loading} tabledata={tabledata} totalRecords={totalRecords} cusfilter={cusfilter} editfrom={editfrom} handledelete={handledelete}
            clearFilter={clearFilter} tempFilterValues={tempFilterValues} setTempFilterValues={setTempFilterValues} first={first} 
        />
        {totalRecords > 0 && (<Cuspagination page={page} rows={rows} onPage={onPage} totallength={totalRecords} />)}
        <ConfirmDialog />
        </>
    )
}